module.exports = __webpack_public_path__ + "static/media/puerta_gris.c38850ab.jpg";